import {RoleMasterForm as RoleMasterFormType} from "../../../models/config/RoleMaster";
import {useRef} from "react";
import {RoleMasterForm, RoleMasterFormRefHandle} from "./RoleMasterForm";
import {Button, Modal, ModalBody, ModalFooter, ModalHeader} from "reactstrap";

export type RoleMasterFormModalProps = {
    title: string;
    isOpen: boolean;
    onClose: () => void;
    disabledKeyField?: boolean;
    defaultValues?: RoleMasterFormType;
    onSubmit?: (formValues: RoleMasterFormType) => void;
};

export const RoleMasterFormModal = (props: RoleMasterFormModalProps) => {
    const {
        disabledKeyField,
        title,
        isOpen,
        onClose,
        defaultValues,
        onSubmit
    } = props;

    const formRef = useRef<RoleMasterFormRefHandle>(null);

    const handleSaveClick = () => {
        const formValues = formRef.current?.submit();
        if (!formValues) {
            return;
        }

        onSubmit?.(formValues);
    };

    return (
        <Modal
            isOpen={isOpen}
            toggle={onClose}
        >
            <ModalHeader toggle={onClose}>{title}</ModalHeader>
            <ModalBody>
                <RoleMasterForm
                    ref={formRef}
                    disabledKeyField={disabledKeyField}
                    defaultValues={defaultValues}
                />
            </ModalBody>
            <ModalFooter className="tw-flex tw-justify-end">
                <Button
                    color="primary"
                    onClick={handleSaveClick}
                >
                    Save
                </Button>
                <Button
                    color="secondary"
                    onClick={onClose}
                    className="tw-border-none tw-bg-neutral-600"
                >
                    Cancel
                </Button>
            </ModalFooter>
        </Modal>
    );
}